import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'


const Contacts = () => {
  


  return (
    <>
      <main>
        <Header />
      <div className="container">
        <h1 className="commonTitle">Контакты</h1>
        <div className="commonBreadcrumbs">
          <ul>
              <li><Link to="/"><i className="fa-solid fa-house-chimney"></i></Link></li>
              /
              <li>Контакты</li>
          </ul>
        </div>
        <div className='contactsContent'>
          <div className="footerContactsWrap">
            <div className="footerContactItem">
                <a href="tel:+77717595949"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (771) 759-59-49 </a>
            </div>
            <div className="footerContactItem">
                <a href="tel:+77272902098"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (727) 290 20 98</a>
            </div>
            <div className="footerContactItem">
                <a href="mailto:info@optech.kz"><i className="fas fa-envelope" aria-hidden="true"></i>info@optech.kz</a>
            </div>
            <div className="footerContactItem">
                <p><i class="fas fa-clock"></i>Пн - Пт: 09:00 AM - 18:00</p>
            </div>
            <div className="footerContactItem">
                <a href="https://go.2gis.com/aml96" target="_blank" rel="noreferrer"><i className="fas fa-map-marker-alt"></i>г. Алматы, ул. Кенесары хана, <br/>дом 83/1, 1 этаж, офис 1Б</a>
            </div>
          </div>
          <div style={{ height: '400px', width: '1000px' }}>
            
          </div>
        </div>
      </div>
      </main>
      <Footer />
    </>
  )
}

export default Contacts